import React from "react";

interface ModeOption<T> {
  value: T;
  label: string;
  icon?: React.ComponentType<{ className?: string }>;
}

interface CourieModeToggleProps<T> {
  options: ModeOption<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

function CourieModeToggle<T>({
  options,
  value,
  onChange,
  className = "",
}: CourieModeToggleProps<T>) {
  return (
    <div className={`flex bg-gray-200 dark:bg-gray-700 rounded-lg p-1 ${className}`}>
      {options.map((option, index) => {
        const isSelected = option.value === value;
        const Icon = option.icon;

        return (
          <button
            key={index}
            type="button"
            className={`flex items-center px-4 py-2 text-sm font-medium rounded-md transition-all ${
              isSelected
                ? "bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow"
                : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
            }`}
            onClick={() => onChange(option.value)}
          >
            {Icon && <Icon className="w-4 h-4 mr-1" />}
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default CourieModeToggle;

